$(function () {
  $(document).on("change", "#split-methods-select", function () {
    let selectedMethod = $(this).val();
    const paymentMethod = selectedMethod;

    if (paymentMethod == "payment_giftcard") {
      $("#split-method-giftcard-validator-container").removeClass("d-none");
      $("#payment-split-button").attr("disabled", true);
      $("#payment-split-input").attr("disabled", true);
    } else if (paymentMethod == "payment_verifone_terminal") {
      $("#payment-split-button").attr(
        "disabled",
        $("body").attr("is-verifone-session-started") == "1" ? false : true,
      );
      $("#payment-split-button").attr(
        "data-terminal-id",
        $("#split-methods-select option:selected").attr("data-terminal-id"),
      );
      $("#split-method-giftcard-validator-container").addClass("d-none");
      $("#payment-split-input").attr("disabled", false);

      if (!isVerifone) {
        $("#payment-split-button").attr("disabled", true);
        checkTerminalAvailability();
      } else {
        $("#payment-split-button").attr("disabled", false);
      }
    } else if (paymentMethod == "payment_terminal") {
      $("#payment-split-button").attr(
        "data-terminal-id",
        $("#split-methods-select option:selected").attr("data-terminal-id"),
      );
      $("#split-method-giftcard-validator-container").addClass("d-none");
      $("#payment-split-button").attr("disabled", false);
      $("#payment-split-input").attr("disabled", false);
    } else {
      $("#split-method-giftcard-validator-container").addClass("d-none");
      $("#payment-split-button").attr("disabled", false);
      $("#payment-split-input").attr("disabled", false);
    }

    $("#payment-split-input").attr("data-payment-method", paymentMethod);
    $("#payment-split-button").attr("data-payment-method", paymentMethod);
  });
});
